(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["camper-calculator"] && !Shopify.designMode) return;
  try {
    
(function() {
  window.camperCalculatorData = function() {
    return {
      appliances: [
        { name: '', power: null, hoursPerDay: null, tempHoursPerDay: '', voltage: '12V', showDropdown: false },
        { name: '', power: null, hoursPerDay: null, tempHoursPerDay: '', voltage: '12V', showDropdown: false },
        { name: '', power: null, hoursPerDay: null, tempHoursPerDay: '', voltage: '12V', showDropdown: false },
      ],
      regions: [
        { name: '', period: '' },
      ],
      calculationValues: {
        panelPower: 420, // standaard paneelvermogen in Wp (nu alleen informatief)
      },
      results: {
        dailyUsage: 0,
        requiredPanels: 0,
        maxRequiredWP: 0,
      },
      totalDevicePower: 0,
      offGridDays: 1,
      previousValues: {
        requiredPanels: null,
        totalDevicePower: null,
        dailyUsage: null,
      },

      init() {
        console.log('Camper Calculator initialized');
        this.calculate();
        this.startWatchingValues();
      },

      startWatchingValues() {
        const checkValues = () => {
          if (
            this.results.requiredPanels !== this.previousValues.requiredPanels ||
            this.totalDevicePower !== this.previousValues.totalDevicePower ||
            this.results.dailyUsage !== this.previousValues.dailyUsage
          ) {
            this.previousValues.requiredPanels = this.results.requiredPanels;
            this.previousValues.totalDevicePower = this.totalDevicePower;
            this.previousValues.dailyUsage = this.results.dailyUsage;

            const event = new CustomEvent("calculatorUpdated", {
              detail: {
                requiredPanels: Math.round(this.results.requiredPanels),
                totalDevicePower: Math.round(this.totalDevicePower),
                dailyUsage: this.results.dailyUsage.toFixed(2),
              },
            });
            document.dispatchEvent(event);
          }

          requestAnimationFrame(checkValues);
        };

        requestAnimationFrame(checkValues);
      },

      addAppliance() {
        this.appliances.push({
          name: '',
          power: null,
          hoursPerDay: null,
          tempHoursPerDay: '',
          voltage: '12V',
          showDropdown: false
        });
        this.calculate();
      },

      removeAppliance(index) {
        this.appliances.splice(index, 1);
        this.calculate();
      },

      addRegion() {
        this.regions.push({ name: '', period: '' });
        this.calculate();
      },

      removeRegion(index) {
        this.regions.splice(index, 1);
        this.calculate();
      },

      calculate() {
        // Dagelijks energieverbruik (kWh)
        const dailyUsage = this.appliances.reduce((sum, appliance) => {
          const power = Number(appliance.power) || 0;
          const hoursPerDay = Number(appliance.hoursPerDay) || 0;
          if (power <= 0 || hoursPerDay <= 0) return sum;

          const adjustedUsage =
            appliance.voltage === '230V'
              ? (power * hoursPerDay * 1.1) / 1000 // 10% extra i.v.m. omvormerverlies
              : (power * hoursPerDay) / 1000;

          return sum + adjustedUsage;
        }, 0);

        // Maximaal benodigd 230V-vermogen (omvormer)
        const totalDevicePower = this.appliances
          .filter(appliance => appliance.voltage === '230V')
          .reduce((max, appliance) => {
            const power = Number(appliance.power) || 0;
            return Math.max(max, power);
          }, 0);

        // Regiogebaseerde PV-berekening
        const regionData = {
          noord: {
            efficiency: 0.73,
            yield: {
              winter: 0.03,
              autumn: 0.12,
              spring: 0.37,
              summer: 0.48,
            },
          },
          west: {
            efficiency: 0.83,
            yield: {
              winter: 0.06,
              autumn: 0.16,
              spring: 0.35,
              summer: 0.43,
            },
          },
          oost: {
            efficiency: 0.97,
            yield: {
              winter: 0.10,
              autumn: 0.18,
              spring: 0.33,
              summer: 0.40,
            },
          },
          zuid: {
            efficiency: 1.34,
            yield: {
              winter: 0.13,
              autumn: 0.20,
              spring: 0.29,
              summer: 0.38,
            },
          },
        };

        let maxRequiredWP = 0;

        this.regions.forEach(region => {
          if (region.name && region.period) {
            const regionKey = region.name === 'heel-europa' ? 'noord' : region.name;
            const regionInfo = regionData[regionKey];

            if (!regionInfo) return;

            const efficiency = regionInfo.efficiency;
            const yieldPercentage = regionInfo.yield[region.period];

            if (yieldPercentage !== undefined) {
              // zelfde formule als je eerdere versie, met extra 10% marge
              const requiredWP =
                ((dailyUsage * 1000) /
                  ((efficiency * 1000) * (yieldPercentage / 91.25))) *
                1.1;
              maxRequiredWP = Math.max(maxRequiredWP, requiredWP);
            }
          }
        });

        const requiredPanels = maxRequiredWP;

        this.results = {
          dailyUsage,
          requiredPanels,
          maxRequiredWP,
        };

        this.totalDevicePower = Math.round(totalDevicePower);
      },
    };
  };

  document.addEventListener('alpine:init', () => {
    Alpine.data('camperCalculatorData', camperCalculatorData);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["camper-featured-products"] && !Shopify.designMode) return;
  try {
      

document.addEventListener("DOMContentLoaded", () => {
    // Luister naar calculatorUpdated events
    document.addEventListener("calculatorUpdated", (event) => {
      const requiredPanels = parseFloat(event.detail.requiredPanels) || 0;
    const totalDevicePower = parseFloat(event.detail.totalDevicePower) || 0;
    const dailyUsage = parseFloat(event.detail.dailyUsage) || 0; // Zet om naar getal
    console.log("Received values:", { requiredPanels, totalDevicePower, dailyUsage }); 
      filterProducts(requiredPanels, totalDevicePower, dailyUsage);
    });

    function filterProducts(requiredPanels, totalDevicePower, dailyUsage) {
    console.log("Filtering with values:", { requiredPanels, totalDevicePower, dailyUsage });
  const productCards = document.querySelectorAll(".product-card");

  productCards.forEach((card) => {
    const productHandle = card.getAttribute("data-handle");
    console.log("Checking Product:", productHandle); // Log elk product
        if (!productHandle) {
      console.log("Skipping Product: No handle found.");
      return; // Overslaan als er geen handle is
    }

        if (requiredPanels > 0 && requiredPanels <= 180 && totalDevicePower <= 1000 && dailyUsage <= 1.20 && (productHandle === "camperkit-budget" || productHandle === "elektrakit-budgetreiziger")) {
    card.style.display = "block";
        } else if (requiredPanels > 0 && requiredPanels <= 360 && totalDevicePower <=1300 && dailyUsage <= 2.4 && !(requiredPanels <= 180 && totalDevicePower <= 1000 && dailyUsage <= 1.2) && (productHandle === "camperkit-adventurer" || productHandle === "elektrakit-adventurer")) {
          card.style.display = "block";
        } else if (requiredPanels > 0 && requiredPanels <= 720 && totalDevicePower <= 2400 && dailyUsage <= 5.52 && !(requiredPanels <= 360 && totalDevicePower <= 1300 && dailyUsage <= 2.4) && (productHandle === "camperkit-digitalnomad" || productHandle === "elektrakit-digitalnomad")) {
          card.style.display = "block";
        } else if (requiredPanels > 0 && requiredPanels < 100000 && totalDevicePower <= 10000 && dailyUsage <= 20 && !(requiredPanels <= 720 && totalDevicePower <= 2400 && dailyUsage <= 5.52) && productHandle === "camperkit-expeditie") {
          card.style.display = "block";
        } else {
          card.style.display = "none";
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solar-calculator"] && !Shopify.designMode) return;
  try {
    
(function() {
  window.solarCalculatorData = function() {
    return {
      // Apparaten
      appliances: [
        { name: '', power: null, tempHoursPerDay: '', hoursPerDay: 0, runsSimultaneously: true, showDropdown: false },
        { name: '', power: null, tempHoursPerDay: '', hoursPerDay: 0, runsSimultaneously: true, showDropdown: false },
        { name: '', power: null, tempHoursPerDay: '', hoursPerDay: 0, runsSimultaneously: true, showDropdown: false }
      ],

      // Presets voor snelle invoer
      presets: {
        ledLamp:            { name: 'LED lamp',                         power: 5,    minutes: 60,  runsSimultaneously: true },
        tvLedLcd:           { name: 'TV (LED/LCD)',                     power: 100,  minutes: 60,  runsSimultaneously: true },
        radio:              { name: 'Radio',                            power: 30,   minutes: 60,  runsSimultaneously: true },
        laptopCharger:      { name: 'Laptop lader',                     power: 60,   minutes: 60,  runsSimultaneously: true },
        phoneCharger:       { name: 'Telefoon lader',                   power: 15,   minutes: 60,  runsSimultaneously: true },
        desktopComputer:    { name: 'Computer (desktop)',               power: 200,  minutes: 60,  runsSimultaneously: true },
        toaster:            { name: 'Broodrooster',                     power: 1000, minutes: 10,  runsSimultaneously: true },
        kettle:             { name: 'Waterkoker',                       power: 1500, minutes: 10,  runsSimultaneously: true },
        coffeeMachine:      { name: 'Koffiezetapparaat',                power: 1500, minutes: 10,  runsSimultaneously: true },
        miniMicrowave:      { name: 'Mini magnetron',                   power: 750,  minutes: 15,  runsSimultaneously: true },
        airFryer:           { name: 'AirFryer',                         power: 1500, minutes: 20,  runsSimultaneously: true },
        toastMachine:       { name: 'Tosti apparaat',                   power: 800,  minutes: 10,  runsSimultaneously: true },
        blender:            { name: 'Blender',                          power: 500,  minutes: 5,   runsSimultaneously: true },
        inductionPlate:     { name: 'Inductie kookplaat (per plaat)',   power: 2000, minutes: 30,  runsSimultaneously: true },
        fridge:             { name: 'Koelkast',                         power: 80,   minutes: 480, runsSimultaneously: true },
        freezer:            { name: 'Diepvries',                        power: 100,  minutes: 480, runsSimultaneously: true },
        dishwasher:         { name: 'Vaatwasser',                       power: 1200, minutes: 90,  runsSimultaneously: true },
        washingMachine:     { name: 'Wasmachine',                       power: 1200, minutes: 90,  runsSimultaneously: true },
        smallHeater:        { name: 'Kleine elektrische kachel',       power: 1500, minutes: 60,  runsSimultaneously: true },
        waterPump:          { name: 'Waterpomp',                        power: 300,  minutes: 30,  runsSimultaneously: true },
        fan:                { name: 'Ventilator',                       power: 50,   minutes: 120, runsSimultaneously: true },
        toolsCharger:       { name: 'Lader elektrisch gereedschap',    power: 60,   minutes: 60,  runsSimultaneously: false },
        securityCamera:     { name: 'Beveiligingscamera',              power: 15,   minutes: 720, runsSimultaneously: true },
        wifiRouter:         { name: 'Wifi-router',                      power: 15,   minutes: 720, runsSimultaneously: true },
        starlink:           { name: 'Starlink',                         power: 50,   minutes: 720, runsSimultaneously: true },
        printer:            { name: 'Printer',                          power: 50,   minutes: 15,  runsSimultaneously: true },
        iron:               { name: 'Strijkijzer',                      power: 1000, minutes: 30,  runsSimultaneously: true },
        vacuumCleaner:      { name: 'Stofzuiger',                       power: 1000, minutes: 30,  runsSimultaneously: true }
      },

      // Instelbare waarden en aannames
      calculationValues: {
        // Dagelijkse opbrengst per kWp (kWh/dag/kWp) – indicatief voor NL/BE
        dailyKwhPerKwp: {
          summer: 4.5,   // gemiddelde zomerdag
          spring: 4.0,   // voorjaar/zomer
          autumn: 2.5,   // najaar
          winter: 1.5    // winter / slechtste maanden
        },
        // Oriëntatie-factoren
        orientationFactors: {
  south: 1.00,          // referentie: zuid, ca. 20°
  south_shaded: 0.80,   // zuid met merkbare schaduw
  east_west: 0.80,      // oost of west, 20°
  east_west_shaded: 0.65,
  north: 0.70,          // noord, 20°
  north_shaded: 0.55    // noord + schaduw
},
        panelPower: 435, // standaard paneelvermogen (Wp)

        // Lithium-accu factoren
        lithiumDoD: 0.8,
        lithiumRoundtrip: 0.95,
        lithiumSafetyMargin: 1.1
      },

      results: {
        dailyUsage: 0,
        requiredPVkWp: { summer: 0, spring: 0, autumn: 0, winter: 0 },
        requiredPanels: { summer: 0, spring: 0, autumn: 0, winter: 0 },
        requiredBatteryCapacityLithium: 0
      },

      totalDevicePower: 0,
      simultaneousPower: 0,
      recommendedInverterPower: 0,

      selectedPeriod: 'summer',
      orientation: 'south',
      offGridDays: 1,

      productAdviceText: '',

      init() {
        console.log('Solar Calculator initialized');
        this.calculate();
      },

      addAppliance() {
        this.appliances.push({
          name: '',
          power: null,
          tempHoursPerDay: '',
          hoursPerDay: 0,
          runsSimultaneously: true,
          showDropdown: false
        });
        this.calculate();
      },

      removeAppliance(index) {
        this.appliances.splice(index, 1);
        this.calculate();
      },

      applyPreset(appliance, preset) {
        if (!preset) return;
        appliance.name = preset.name;
        appliance.power = preset.power;
        appliance.tempHoursPerDay = String(preset.minutes);
        appliance.hoursPerDay = preset.minutes / 60;
        appliance.runsSimultaneously = preset.runsSimultaneously;
        appliance.showDropdown = false;
        this.calculate();
      },

      handleMinutesInput(appliance, event) {
        const value = event.target.value;

        // Tijdelijke waarde opslaan zodat de gebruiker ziet wat hij typt
        appliance.tempHoursPerDay = value;

        // Check op leidende nul (bijv. "01" i.p.v. "1" of "0,1")
        if (/^0[0-9]+$/.test(value)) {
          alert('Ongeldige invoer: een getal mag niet beginnen met een 0 gevolgd door een ander cijfer (bijvoorbeeld 01). Controleer of je geen komma bent vergeten!');
          return;
        }

        let numericValue = parseFloat(value.replace(',', '.'));

        if (isNaN(numericValue)) {
          appliance.hoursPerDay = 0;
          this.calculate();
          return;
        }

        if (numericValue > 1440) {
          alert('Gebruikstijd per dag kan maximaal 1440 minuten zijn (24 uur).');
          return;
        }

        appliance.hoursPerDay = numericValue / 60;
        this.calculate();
      },

      getCurrentPanels() {
        switch (this.selectedPeriod) {
          case 'summer':
            return this.results.requiredPanels.summer;
          case 'spring':
            return this.results.requiredPanels.spring;
          case 'autumn':
            return this.results.requiredPanels.autumn;
          case 'winter':
          default:
            return this.results.requiredPanels.winter;
        }
      },

      getCurrentPeriodLabel() {
        switch (this.selectedPeriod) {
          case 'summer': return 'enkel zomer';
          case 'spring': return 'zomer & voorjaar';
          case 'autumn': return 'voorjaar t/m najaar';
          case 'winter': return 'hele jaar door';
          default: return '';
        }
      },

      displayBatteryResult() {
  const minShownBattery = 0.1;
  const value = Math.max(this.results.requiredBatteryCapacityLithium, minShownBattery);
  return value.toFixed(1).replace('.', ',');
},

      calculate() {
        // Dagelijks verbruik (kWh)
        const dailyUsage = this.appliances.reduce((sum, appliance) => {
          const power = Number(appliance.power) || 0;
          const hoursPerDay = Number(appliance.hoursPerDay) || 0;
          if (power <= 0 || hoursPerDay <= 0) return sum;
          return sum + (power * hoursPerDay) / 1000;
        }, 0);

        // Totaal aangesloten vermogen (W)
        const totalDevicePower = this.appliances.reduce((sum, appliance) => {
          const power = Number(appliance.power) || 0;
          return sum + power;
        }, 0);

        // Gelijktijdige belasting (W)
        const simultaneousPower = this.appliances.reduce((sum, appliance) => {
          const power = Number(appliance.power) || 0;
          const runsSimultaneously = appliance.runsSimultaneously ? 1 : 0;
          return sum + (runsSimultaneously ? power : 0);
        }, 0);

        // Inverter-advies (veiligheidsfactor)
        const inverterSafetyFactor = 1.2;
        const recommendedInverterPower = Math.round(simultaneousPower * inverterSafetyFactor);

        // PV-berekening
        const orientationFactor = this.calculationValues.orientationFactors[this.orientation] || 0.9;
        const dailyKwhPerKwp = this.calculationValues.dailyKwhPerKwp;

        // Systeemverliezen (MPPT, omvormer, bekabeling)
        const mpptEfficiency = 0.97;
        const inverterEfficiency = 0.95;
        const wiringLoss = 0.98;
        const systemLossFactor = mpptEfficiency * inverterEfficiency * wiringLoss;

        const panelWp = this.calculationValues.panelPower > 0 ? this.calculationValues.panelPower : 1;
        const oversizeFactor = 1.25;

        const requiredPVkWp = {
          summer: dailyUsage / (orientationFactor * systemLossFactor * dailyKwhPerKwp.summer || 1),
          spring: dailyUsage / (orientationFactor * systemLossFactor * dailyKwhPerKwp.spring || 1),
          autumn: dailyUsage / (orientationFactor * systemLossFactor * dailyKwhPerKwp.autumn || 1),
          winter: dailyUsage / (orientationFactor * systemLossFactor * dailyKwhPerKwp.winter || 1)
        };

        const requiredPanels = {
          summer: Math.max(0, Math.ceil(requiredPVkWp.summer * 1000 * oversizeFactor / panelWp)),
          spring: Math.max(0, Math.ceil(requiredPVkWp.spring * 1000 * oversizeFactor / panelWp)),
          autumn: Math.max(0, Math.ceil(requiredPVkWp.autumn * 1000 * oversizeFactor / panelWp)),
          winter: Math.max(0, Math.ceil(requiredPVkWp.winter * 1000 * oversizeFactor / panelWp))
        };

        // Accu-berekening (lithium), onafhankelijk van seizoen
        const lithiumDoD = this.calculationValues.lithiumDoD;
        const lithiumRoundtrip = this.calculationValues.lithiumRoundtrip;
        const lithiumSafetyMargin = this.calculationValues.lithiumSafetyMargin;
        const lithiumFactor = lithiumSafetyMargin / (lithiumDoD * lithiumRoundtrip); // ≈ 1.45

        const requiredBatteryCapacityLithium = dailyUsage * this.offGridDays * lithiumFactor;

        // Resultaten opslaan
        this.results = {
          dailyUsage: dailyUsage,
          requiredPVkWp: requiredPVkWp,
          requiredPanels: requiredPanels,
          requiredBatteryCapacityLithium: requiredBatteryCapacityLithium
        };

        this.totalDevicePower = Math.round(totalDevicePower);
        this.simultaneousPower = Math.round(simultaneousPower);
        this.recommendedInverterPower = recommendedInverterPower;

        // Productadvies op basis van dagverbruik
              // Productadvies op basis van dagverbruik
let advice = '';

if (dailyUsage === 0) {
  advice = '';
} else {
  const panelsCurrentRaw = this.getCurrentPanels();
  const panelsCurrent = Math.max(1, panelsCurrentRaw || 1);
  const batteryKwh = this.results.requiredBatteryCapacityLithium;
  const inverterNeeded = this.recommendedInverterPower;

  // helpers voor NL-notatie
  const formatKwh = (kwh) => {
    const safe = kwh > 0 ? kwh : 0;
    return safe.toFixed(1).replace('.', ',');
  };
  const formatWatt = (w) => Math.round(w);

  // === MAATWERKCHECK ===
const maatwerkRedenen = [];

if (panelsCurrent > 16) {
  maatwerkRedenen.push('het benodigde aantal zonnepanelen groter is dan 16');
}

if (batteryKwh > 28.8) {
  maatwerkRedenen.push('de benodigde accucapaciteit hoger is dan 28,8 kWh');
}

if (inverterNeeded > 6400) {
  maatwerkRedenen.push('het benodigde omvormervermogen hoger is dan 6400 W');
}

if (maatwerkRedenen.length > 0) {
  let redenenTekst = '';

if (maatwerkRedenen.length === 1) {
  redenenTekst = maatwerkRedenen[0];
} else if (maatwerkRedenen.length === 2) {
  redenenTekst = maatwerkRedenen.join(' en ');
} else {
  redenenTekst =
    maatwerkRedenen.slice(0, -1).join(', ') +
    ' en ' +
    maatwerkRedenen[maatwerkRedenen.length - 1];
}

  this.productAdviceText =
    `<strong>Advies:</strong> je vraag valt buiten het bereik van onze gestandaardiseerde sets, omdat ${redenenTekst}. ` +
    `Neem <a href="/pages/contact"><strong><u>contact</u></strong></a> met ons op voor een maatwerkconfiguratie.`;

  return;
}

  // === REGULIER ADVIES ===

// 1) Panelen-advies
const panelsText =
  panelsCurrent <= 1
    ? `<strong>Advies:</strong> je hebt een systeem nodig met minimaal 1 zonnepaneel.`
    : `<strong>Advies:</strong> je hebt een systeem nodig met minimaal ${panelsCurrent} zonnepanelen.`;

// 2) Accu-advies
const batteryOptions = [0.6, 1.2, 2.4, 4.8, 9.6, 14.4, 19.2, 24.0, 28.8];

let advisedBattery =
  batteryOptions.find((b) => b >= batteryKwh) || 28.8;

const minShownBattery = 0.1;
const shownBatteryKwh = Math.max(batteryKwh, minShownBattery);

const batteryText = 
  ` Daarnaast heb je een accupakket nodig met een minimale opslagcapaciteit van ` +
  `${formatKwh(shownBatteryKwh)} kWh. De accu die hier het dichtst bij in de buurt komt ` +
  `heeft een opslagcapaciteit van ${formatKwh(advisedBattery)} kWh.`;

// 3) Omvormer-advies
const inverterOptions = [400, 650, 1000, 1300, 1600, 2400, 4000, 6400];

let advisedInverter =
  inverterOptions.find((p) => p >= inverterNeeded) || 6400;

const inverterText =
  ` Als laatste heb je een omvormer nodig met een minimaal uitgangsvermogen van ` +
  `${formatWatt(inverterNeeded)} W. De meest passende beschikbare optie daarbij ` +
  `is een omvormer van ${advisedInverter} W.`;

// 4) Systeemverliezen
const lossesText =
  `<br><br>Systeem- en oriëntatieverliezen zijn in de berekening van het advies opgenomen.<br><br><strong>Lees hieronder</strong> welk systeem past bij je behoefte.`;

// alles samenvoegen
advice = panelsText + batteryText + inverterText + lossesText;
}

this.productAdviceText = advice;

      }
    };
  };

  document.addEventListener('alpine:init', () => {
    Alpine.data('solarCalculatorData', solarCalculatorData);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
